<template>
  <div class="main">
    <div class="left">
      <el-radio-group v-model="radio1" @change="hideAllDeleteIcons()">
        <el-radio-button
          v-for="item in radioList"
          :key="item.typeId"
          :label="item.typeId"
          size="medium"
        >
          {{ item.pasteType }}
          <span
            v-if="item.showDelete"
            class="delete-icon"
            @click.stop="deleteItem(item)"
          >
            <i class="el-icon-remove-outline" />
          </span>
        </el-radio-button>
      </el-radio-group>
      <el-button-group style="margin: 10px 0" class="radio-add">
        <el-button
          icon="el-icon-plus"
          size="medium"
          @click="RlistAdd"
        >添加</el-button>
        <el-button v-if="delet == true" size="medium" @click="deleteButton">删除</el-button>
        <el-button v-if="delet == false" size="medium" @click="deleteButton">取消</el-button>
      </el-button-group>
    </div>
    <div class="right">
      <!-- 输入框 和添加按钮 -->
      <div class="input-box">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入内容"
          style="width: 50%; margin: 10px 0"
          @input="filteredItems"
        />
        <el-button
          icon="el-icon-plus"
          size="medium"
          @click="additems"
        >添加</el-button>
      </div>
      <div class="content-box">
        <el-collapse
          v-if="items.length > 0"
          v-model="activeNames"
          @change="handleChange"
        >
          <draggable
            v-model="filteredItems"
            :options="dragOptions"
            @end="onDragEnd"
          >
            <template v-for="(item, index) in filteredItems">
              <el-collapse-item
                :key="item.infoId"
                :name="'item-' + item.infoId"
                class="custom-collapse-item"
              >
                <template slot="title">
                  <div class="title-content collapse-title">
                    <div class="left-section">
                      <span class="handle">☰</span>
                      <span class="title-text">{{ item.pasteName }}</span>
                    </div>
                    <div class="right-section">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="删除"
                        placement="top"
                      >
                        <i
                          style="margin: 0 2px"
                          class="el-icon-delete"
                          @click="deletcontent(item)"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="复制"
                        placement="top"
                      >
                        <i
                          v-clipboard:copy="item.pasteContent"
                          v-clipboard:success="onCopySuccess"
                          style="margin: 0 2px"
                          class="el-icon-document-copy"
                        />
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="编辑"
                        placement="top"
                      >
                        <i
                          style="margin: 0 2px"
                          class="el-icon-edit"
                          @click="editItem(item)"
                        />
                      </el-tooltip>
                    </div>
                  </div>
                </template>
                <div style="padding: 10px">
                  {{ item.pasteContent }}
                </div>
              </el-collapse-item>
            </template>
          </draggable>
        </el-collapse>
        <el-empty v-else description="暂无备忘录" />
        <!-- 出现滚动条显示回到顶部图标 -->
      </div>
    </div>
    <el-dialog
      title="添加分类"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <div style="margin-top: 20px" />
      <el-form label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="title" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addItem">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="pageid == 1 ? '添加备忘录' : '修改备忘录'"
      :visible.sync="dialogVisible1"
      width="30%"
      :append-to-body="true"
    >
      <div style="margin-top: 20px" />
      <el-form label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="from.pasteName" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="from.pasteContent"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary" @click="addconten">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  group,
  groupAdd,
  pastelist,
  addRemark,
  sort,
  groupDel,
  del,
  edit,
  search
} from '../../api/sso/user.js'
import draggable from 'vuedraggable'
import ClipboardJS from 'clipboard'
export default {
  name: 'Memorandum',
  components: {
    draggable
  },
  mixins: [],
  data() {
    return {
      pageid: 1,
      radio1: '',
      radioList: [],
      dialogVisible: false,
      title: '',
      content: '',
      activeNames: ['1'],
      items: [],
      dragOptions: {
        handle: '.handle'
      },
      searchKeyword: '',
      delet: true,
      dialogVisible1: false,
      from: {
        pasteName: '',
        pasteContent: '',
        infoId: '',
        pasteTypeId: '',
        typeId: ''
      }
    }
  },
  computed: {
    filteredItems() {
      if (this.searchKeyword == '') {
        return this.items
      } else {
        return this.items.filter((item) => {
          return item.pasteName.toLowerCase().includes(this.searchKeyword.toLowerCase())
        })
      }
    }
  },
  mounted() {
    this.Rlist()
  },
  methods: {
    deletcontent(item) {
      this.$confirm('此操作将删除该备忘录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = {
            infoId: item.infoId,
            pasteTypeId: item.pasteTypeId,
            pasteName: item.pasteName,
            pasteContent: item.pasteContent,
            sort: item.sort,
            typeId: item.typeId
          }
          del(data).then((res) => {
            if (res.code == 200) {
              this.hideAllDeleteIcons()
              this.$message({
                type: 'info',
                message: `删除成功`
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    editItem(item) {
      this.pageid = 2
      this.dialogVisible1 = true
      this.from.infoId = item.infoId
      this.from.pasteTypeId = item.pasteTypeId
      this.from.typeId = item.typeId
      this.from.pasteName = item.pasteName
      this.from.pasteContent = item.pasteContent
    },
    onCopySuccess() {
      this.$message({
        type: 'success',
        message: '已复制到剪贴板'
      })
    },
    addconten() {
      if (this.pageid == 1) {
        const data = {
          pasteTypeId: this.radio1,
          pasteName: this.from.pasteName,
          pasteContent: this.from.pasteContent
        }
        addRemark(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.hideAllDeleteIcons()
            this.dialogVisible1 = false
          }
        })
      } else {
        const data = {
          infoId: this.from.infoId,
          pasteTypeId: this.from.pasteTypeId,
          pasteName: this.from.pasteName,
          pasteContent: this.from.pasteContent,
          sort: this.from.sort,
          typeId: this.from.typeId
        }
        edit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.hideAllDeleteIcons()
            this.dialogVisible1 = false
          }
        })
      }
    },
    additems() {
      this.pageid = 1
      this.from.pasteName = ''
      this.from.pasteContent = ''
      this.dialogVisible1 = true
    },
    onDragEnd(evt) {
    // 获取拖动前的索引
      const oldIndex = evt.oldIndex
      // 获取拖动后的索引
      const newIndex = evt.newIndex
      // 获取拖动的数据
      const draggedItem = this.filteredItems[oldIndex]
      console.log('目标位置：', newIndex)
      const data = {
        infoId: draggedItem.infoId,
        pasteTypeId: draggedItem.pasteTypeId,
        pasteName: draggedItem.pasteName,
        pasteContent: draggedItem.pasteContent,
        sort: newIndex,
        typeId: draggedItem.typeId,
        newSort: newIndex
      }
      sort(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '排序成功'
          })
        }
      })
      // 更新数据的顺序
      this.filteredItems.splice(oldIndex, 1)
      this.filteredItems.splice(newIndex, 0, draggedItem)
    },
    handleChange(val) {
      console.log(val)
    },
    deleteButton() {
      this.delet = !this.delet
      if (this.delet == true) {
        this.radioList.forEach((item) => {
          item.showDelete = false
        })
      } else {
        this.radioList.forEach((item) => {
          item.showDelete = true
        })
      }
    },
    hideAllDeleteIcons() {
      this.delet = true
      for (const item of this.radioList) {
        item.showDelete = false
      }
      const data = {
        typeId: this.radio1
      }
      pastelist(data).then((res) => {
        this.items = res.data || []
        this.filteredItems()
      })
    },
    deleteItem(item) {
      const data = {
        typeId: item.typeId
      }
      groupDel(data).then((res) => {
        if (res.code == 200) {
          this.Rlist()
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    addItem() {
      if (this.title) {
        const data = {
          pasteType: this.title
          //   typeId: this.content
        }
        groupAdd(data).then((res) => {
          if (res.code == 200) {
            this.$message.success('添加成功')
            this.Rlist()
          } else {
            this.$message.error(res.message)
          }
        })
        this.Rlist()
        this.dialogVisible = false
      } else {
        this.$message.error('请填写完整信息')
      }
    },
    RlistAdd() {
      this.title = ''
      this.dialogVisible = true
    },
    Rlist() {
      const data = {}
      group(data).then((res) => {
        for (const item of res.data) {
          item.showDelete = false
        }
        this.radioList = res.data
        // 默认选中第一项
        this.radio1 = this.radioList[0].typeId
        this.hideAllDeleteIcons()
        console.log(this.radioList, ' this.radioList')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  display: flex;
  width: 100%;
  height: 100%;
  .left {
    width: 25%;
    height: 100%;
    // border: 1px solid #ccc;
    display: flex;
    flex-direction: column; /* 设置 flex-direction 为 column */
    align-items: stretch;
    background: rgba(0, 0, 0, 0.02);
    flex-wrap: wrap; /* 添加 flex-wrap 属性 */
    .el-button-group {
      width: 100% !important;
    }
    .radio-group {
      .el-button--medium {
        width: 100% !important;
        display: block !important;
        word-wrap: break-word !important;
        white-space: normal !important;
        height: 50px !important;
        background: rgba(0, 0, 0, 0.02);
      }
    }
    .radio-add {
      .el-button--medium {
        width: 90% !important;
        display: block !important;
        word-wrap: break-word !important;
        white-space: normal !important;
        height: 30px !important;
        margin: 5px;
      }
    }
    .delete-icon {
      border-radius: 0px;
      width: 32px;
      height: 50px;
      display: block;
      position: absolute;
      right: -1px;
      top: -1px;
      // height: 100%;
      background: red;
      color: #fff;
      /* margin: 20px; */
      padding: 14px 0;
      font-size: 20px;
      //添加动画滑动出现
      animation: slide-in 0.3s ease-in-out forwards;
    }
    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0);
      }
    }
  }
  .right {
    width: 75%;
    height: 100%;
    background: #fff;
    padding: 0px 10px;
    overflow: auto;
   .el-collapse {
      border-radius: 8px;
    }
    .input-box {
      display: flex;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-button--medium {
        width: 16% !important;
        display: block !important;
        word-wrap: break-word !important;
        white-space: normal !important;
        height: 30px !important;
        font-size: 12px !important;
        padding: 0 !important;
        margin: 0 5px !important;
      }
    }
    ::v-deep .collapse-title {
      flex: 1 0 90%;
      order: 1;
      .el-collapse-item__header {
        flex: 1 0 auto;
        order: -1;
      }
      .content-box {
        border: 1px solid #ccc;
        border-radius: 8px;
        overflow: auto;
      }
    }

    .draggable-collapse .el-collapse {
      border-radius: 8px;
    }
    .draggable-collapse .handle {
      cursor: grab;
      //   margin-right: 8px;
    }
    .title-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-section {
      display: flex;
      align-items: center;
    }

    .right-section {
      display: flex;
      align-items: center;
      margin: 0 2px;
      font-size: 16px;
    }

    .title-text {
      margin-left: 10px;
    }
    .el-drawer__header{
        margin-bottom: 12px !important;
    }
  }
  ::v-deep .el-collapse-item__header {
    border-radius: 8px !important;
    background: rgba(0, 0, 0, 0.02);
    padding: 5px 5px;
    flex: 1 0 auto;
    order: -1;
    display: flex;
    .el-collapse-item__arrow {
      margin: 0;
    }
  }
  ::v-deep .el-radio-button {
    width: 100% !important;
    .el-radio-button__inner {
      width: 100% !important;
      height: 50px !important;
      border-radius: none;
      line-height: 25px;
    }
  }
  .v-modal {
    z-index: 2020 !important;
  }
}
</style>
